import React from 'react';
import PropTypes from 'prop-types';

import { useGetFulfillmentPlanAmountSummary } from '../hooks/use-calculate-amount-summary';
import CurrencyColumn from '../../../components/columns/currency-column';
import { messages } from './messages';

const TaxPaidColumn = ({ fulfillmentPlanId }) => {
  const amountSummary = useGetFulfillmentPlanAmountSummary(fulfillmentPlanId);
  if (!amountSummary?.taxAmount) {
    return '';
  }
  const { value, code } = amountSummary.taxAmount;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

TaxPaidColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const TaxPaid = {
  getMessageDescriptor: () => messages.taxPaid,
  id: 'taxPaid',

  render: (data, { isFirstOfType = true } = {}) => {
    if (!isFirstOfType) {
      return null;
    }

    return <TaxPaidColumn fulfillmentPlanId={data.id} />;
  },
};
